<template>
    <section class="city_component">
		<van-popup v-model="isCityModel" round position="bottom" :style="{ height: '98%' }" class="login_model" :close-on-click-overlay="false">
			<section class="login_box" v-if="type == 'province'">
				<van-nav-bar title="选择城市" left-text="取消" @click-left="closeModel" />
				<div class="scroll">
					<p class="position_tit">定位到的城市</p>
					<div>
						<h3 v-if="city!=''" @click="chooseWeizhi">
							<img src="../../assets/img/location_icon.png" />
							<p>{{city}}</p>
						</h3>
						<h3 v-else class="no_position_android" @click="permissions">
							<img src="../../assets/img/location_icon.png" />
							<p>请在系统设置中授权</p>
							<p class="authorization">去授权<van-icon name="arrow" /></p>
						</h3>
					</div>
					<p class="all_tit">全部</p>
					<div class="list">
						<p v-for="(item, i) in cityJson" :key="item.code" @click="changeProvince(i)">
							<span>{{item.name}}</span>
							<van-icon name="arrow" />
						</p>
					</div>
				</div>
			</section>
			<section v-else-if="type=='city'">
				<van-nav-bar :title="activeProvince" left-arrow @click-left="type='province'" />
				<div class="scroll">
					<div class="lists">
						<p v-for="item in activeCityList" :key="item.code" @click="chooseCity(item.name)">
							<span>{{item.name}}</span>
						</p>
					</div>
				</div>
			</section>
		</van-popup>
	</section>
</template>

<script>
import LoginServer from "api/login"
import cityJson from "assets/json/city"


export default {
    name: "login",
	props: {
		isCityModel: Boolean,
		city: String
	},
	components: {
	},
    data() {
		//type: login, yinsi, yonghu, kehu
        return {
			cityJson,
			params: {
				phone: '',
				systemId: 1,
				
			},
			clientType: this.$store.state.clientType,
			type: 'province',
			activeCityList: [],
			activeProvince: '',


		};
		
    },
    created() {
	},
    methods: {
		changeProvince(i) {
			this.type = 'city'
			this.activeProvince = this.cityJson[i].name
			this.activeCityList = this.cityJson[i].city
		},
		chooseCity(name) {
			this.$emit('chooseCity', this.activeProvince, name)
		},
		timeFinish() {
			this.isSend = false
		},
		closeModel() {
			this.$emit('closeModel')
		},
		permissions() {
			this.$emit('watchPosition')
		},
		chooseWeizhi() {
			this.$emit('chooseWeizhi')
		}
	}
};
</script>

<style lang="scss">
	.city_component {
		position: relative;
		.van-nav-bar {
			position: fixed;
			width: 100%;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
		}
		.scroll {
			padding-top: 62px;
			padding-bottom: 50px;
			// height: 300px;
			// overflow-y: scroll;
		}
		.van-nav-bar__text {
			color: #7D8290;
			font-size: 16px;
			font-weight: bold;
		}
		.van-nav-bar__title {
			color: #2B2F3A;
			font-size: 17px;
		}
		.van-nav-bar__content {
			height: 62px;
		}
		.position_tit, .all_tit {
			font-size: 14px;
			color: #575F72;
			height: 28px;
			line-height: 28px;
			background: #EDEFF4;
			padding-left: 16px;
		}
		h3 {
			display: flex;
			align-items: center;
			height: 56px;
			padding-left: 16px;
			img {
				width: 12px;
			}
			p {
				font-weight: bold;
				color: #2B2F3A;
				padding-left: 4px;
				
			}
		}
		.no_position_android {
			position: relative;
			.authorization {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				right: 16px;
			}
		}
		.list, .lists {
			p {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 16px;
				height: 53px; 
				border-bottom: 1Px solid #F6F6F6;
				span {
					font-size: 16px;
					color: #2B2F3A;
				}
				.van-icon-arrow {
					font-size: 18px;
					color: #575F72;
				}
			}
		}
		.lists {
			p {
				border-bottom: 0;
				border-top: 1Px solid #F6F6F6;
			}
		}



		.van-nav-bar__left {
			.van-icon-arrow-left {
				color: #979797;
				font-size: 22px;
			}
		}
		.van-count-down {
			display: inline-block;
			color: #A2A6AE;
			font-size: 16px;
		}
		.fix_top {
			// position: absolute;
			// top: 0;
			// left: 0;
			// width: 100%;
			// z-index: 99;
		}
}
</style>


// WEBPACK FOOTER //
// src/views/components/City.vue